(function(){
  function shuffle(array){for(var i=array.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=array[i];array[i]=array[j];array[j]=t;}return array;}

  document.querySelectorAll('[data-random-images]').forEach(function(img){
    var images=(img.dataset.randomImages||'').split('||').map(function(x){return x.trim();}).filter(Boolean);
    if(images.length>1){img.src=images[Math.floor(Math.random()*images.length)];}
  });

  document.querySelectorAll('[data-randomize-grid] .product-grid').forEach(function(grid){
    var cards=[].slice.call(grid.children);
    var featured=cards.filter(function(c){return c.dataset.featured==='true';});
    var normal=shuffle(cards.filter(function(c){return c.dataset.featured!=='true';}));
    featured.concat(normal).forEach(function(c){grid.appendChild(c);});
  });

  document.querySelectorAll('[data-product-detail]').forEach(function(root){
    var productScript=root.querySelector('[data-product-json]');
    if(!productScript) return;

    var product=JSON.parse(productScript.textContent);
    var variantSelect=root.querySelector('#VariantSelect');
    var price=root.querySelector('#ProductPrice');
    var mainImage=root.querySelector('#ProductMainImage');
    var submit=root.querySelector('button[type="submit"]');
    var thumbs=[].slice.call(root.querySelectorAll('.thumbs button'));

    function variantImageId(variant){
      return variant && variant.featured_image ? String(variant.featured_image.id) : '';
    }

    function selectedOptions(){
      return [].slice.call(root.querySelectorAll('.option-group')).map(function(fs){
        var checked=fs.querySelector('input:checked');
        return checked && checked.value;
      });
    }

    function setCheckedOptions(variant){
      if(!variant || !variant.options) return;
      variant.options.forEach(function(value,index){
        var input=root.querySelector('.option-group input[data-option-position="'+(index+1)+'"][value="'+CSS.escape(value)+'"]');
        if(input) input.checked=true;
      });
    }

    function markActiveThumb(imageId){
      thumbs.forEach(function(btn){btn.classList.toggle('is-active', imageId && btn.dataset.imageId===String(imageId));});
    }

    function updateUrl(variant){
      if(!variant || !window.history || !window.history.replaceState) return;
      var url=new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function applyVariant(variant, updateAddress){
      if(!variant) return;
      variantSelect.value=variant.id;
      var option=[].slice.call(variantSelect.options).find(function(o){return o.value==variant.id;});
      if(option){
        if(price) price.textContent=option.dataset.price;
        if(option.dataset.image && mainImage){
          mainImage.src=option.dataset.image;
          markActiveThumb(option.dataset.imageId);
        }
        if(submit){
          submit.disabled=option.dataset.available!=='true';
          submit.textContent=submit.disabled?'Uitverkocht':'In winkelwagen';
        }
      }
      setCheckedOptions(variant);
      if(updateAddress) updateUrl(variant);
    }

    function syncVariant(){
      var opts=selectedOptions();
      var variant=product.variants.find(function(v){
        return v.options.every(function(o,i){return o===opts[i];});
      });
      applyVariant(variant, true);
    }

    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var variant=null;
        if(btn.dataset.variantId){
          variant=product.variants.find(function(v){return String(v.id)===String(btn.dataset.variantId);});
        }
        if(!variant && btn.dataset.imageId){
          variant=product.variants.find(function(v){return variantImageId(v)===String(btn.dataset.imageId);});
        }
        if(variant){
          applyVariant(variant, true);
        }else if(mainImage && btn.dataset.image){
          mainImage.src=btn.dataset.image;
          markActiveThumb(btn.dataset.imageId);
        }
      });
    });

    root.querySelectorAll('.option-group input').forEach(function(input){input.addEventListener('change',syncVariant);});
    syncVariant();
  });
})();
